// ===================================================================
// KAIXO - Calls API (llamadas voz/video con LiveKit)
// ===================================================================

import api from './api';

// Normaliza ids (misma lógica que otros servicios: evitar [object Object])
function id(v) {
    if (!v) return '';
    if (typeof v === 'string') return v === '[object Object]' ? '' : v;
    if (typeof v === 'object') {
        if (typeof v.toHexString === 'function') {
            try { return v.toHexString(); } catch { /* noop */ }
        }
        return String(v._id || v.id || '');
    }
    return String(v);
}

// GET público — el frontend lo consulta al arrancar para saber si
// las llamadas están habilitadas en este backend (y qué URL usar).
export const callsGetConfig = () => api.get('/calls/config');

// Iniciar llamada. Devuelve { callId, roomName, token, url, type }.
export const callsInitiate = (calleeId, type = 'voice', groupId = null) =>
    api.post('/calls/initiate', {
        calleeId: id(calleeId),
        type,
        groupId: groupId ? id(groupId) : null
    });

// El callee acepta. Devuelve { callId, roomName, token, url, type }.
export const callsAccept = (callId) =>
    api.post(`/calls/${id(callId)}/accept`);

// El callee rechaza (antes de conectar).
export const callsDecline = (callId) =>
    api.post(`/calls/${id(callId)}/decline`);

// El caller cancela (antes de que el callee responda).
export const callsCancel = (callId) =>
    api.post(`/calls/${id(callId)}/cancel`);

// Alguien cuelga (conexión establecida).
export const callsEnd = (callId) =>
    api.post(`/calls/${id(callId)}/end`);

// Invitar a más personas a una llamada en curso (mid-call invite).
// Convierte una llamada 1-a-1 en grupal sin necesidad de colgar y rellamar.
export const callsInvite = (callId, userIds) =>
    api.post(`/calls/${id(callId)}/invite`, {
        userIds: (userIds || []).map(id)
    });

// Historial de llamadas del usuario actual.
export const callsHistory = (limit = 50) =>
    api.get('/calls/history', { params: { limit } });

// Detalle de una llamada.
export const callsGet = (callId) =>
    api.get(`/calls/${id(callId)}`);
